import CreateCategoryRequestModelBase from '../_generated/modelBases/create-category-request-model-base';

export default class CreateCategoryRequestModel extends CreateCategoryRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
